export const timeZoneMapping = {
    africa: 'eu',
    america: 'na',
    antarctica: 'na',
    arctic: 'na',
    asia: 'oc',
    atlantic: 'na',
    australia: 'oc',
    europe: 'eu',
    indian: 'oc',
    pacific: 'na',
};
